/* eslint-disable no-plusplus */
<template>
  <div class="wrapper">
    <dashboard-bar refreshButton />
    <div class="wrapp">
      <div class="row">
        <div class="col-lg-3" refreshButton>
          <span class="header-icon">
            <font-awesome-icon :icon="['fas', 'sync-alt']" />
          </span>
          <h2>{{ $t('sentiment.pageTitle') }}</h2>
        </div>
      </div>
      <div>
        <div class="row data-filter">
          <div class="col-3 mt-3">
            <div class="search-answers">
              <input
                type="text"
                class="form-control"
                id="input-answer"
                :placeholder="$t('answers.searchInput')"
                v-model="filter"
                @keyup="searchByFilter"
              />
              <button @click="cleanFilter" class="btn btn-outline-primary">
                {{ $t('answers.searchButton') }}
              </button>
            </div>
          </div>
          <div class="col-2 mt-3 ml-3 p-0">
            <b-form-select
              @change="selectProfile"
              v-model="profileSelect"
              :options="profileOptions"
            ></b-form-select>
          </div>
          <div class="col-2 mt-3 ml-3 p-0">
            <b-form-select
              @change="selectSentiment"
              v-model="sentimentSelect"
              :options="sentimentOptions"
            ></b-form-select>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-table
              striped
              @sort-changed="sortingChanged"
              no-local-sorting
              id="sentiment-table"
              class="mt-4"
              :items="items"
              :fields="fields"
              :busy="loading"
              responsive
            >
              <template v-slot:table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner type="grow" class="align-middle"></b-spinner>
                </div>
              </template>
              <!-- Data -->
              <template v-slot:cell(date)="row">
                {{ dateFormat(new Date(row.item.date)) }}
              </template>
              <!-- Nota -->
              <!--
              <template v-slot:cell(review)="row">
                <div
                  :class="`flag-grade flag-grade-${gradeFormat(
                    row.item.review,
                  )}`"
                >
                  <span v-if="row.item.review != '99'">{{
                    row.item.review
                  }}</span>
                  <span v-else>-</span>
                </div>
              </template>
              -->
              <!-- Cliente -->
              <template v-slot:cell(name)="row">
                <span style="font-weight: bold;">{{
                  checkName(row.item.anonymousResponse, row.item.name)
                }}</span>
                <br />
                <span class="user-info">
                  {{
                    checkUserData(row.item.anonymousResponse, row.item.email)
                  }}
                </span>
                <br />
                <span class="user-info">
                  {{
                    checkUserData(row.item.anonymousResponse, row.item.phone)
                  }}
                </span>
                <br />
                <!--
                <span class="user-info"
                  >{{ $t('answers.answerTable.labels.id') }}:
                  <span style="font-weight: bold;">
                    {{ row.item.controlId }}
                  </span>
                </span>
                -->
                <!--
                <span class="user-info"
                  >{{ $t('answers.channel') }}: {{ row.item.channel }}</span
                >
                <br />
                <span class="user-info">
                  {{ $t('answers.action') }}: {{ row.item.actionId.name }}</span
                >
                <br />
                <span class="user-info">
                  {{ $t('answers.metric') }}:
                  {{
                    row.item.metric === 'nps-0-10' ? 'NPS 0 a 10' : 'NPS 1 a 5'
                  }}
                </span>
                -->
              </template>
              <!-- Comment -->
              <template v-slot:cell(comment)="row">
                <div v-if="row.item.feedbackEdited.edition">
                  {{ row.item.feedbackEdited.edition }}
                  <span>
                    <i
                      class="fas fa-pen ml-1"
                      style="font-size: 12px; color: #c1c1c1;"
                      :title="`${$t('answers.feedbackEdited', {
                        feedbackEditedAutor: `${row.item.feedbackEdited.author}`,
                      })}`"
                    ></i>
                  </span>
                </div>
                <div v-else>{{ row.item.feedback }}</div>
              </template>
              <!-- Sentiment -->
              <template v-slot:cell(sentiment)="row">
                <div class="text-center">
                  <img
                    :src="require(`../../../assets/${row.item.sentiment}.gif`)"
                  />
                  <br />
                  <span
                    :class="`flag-sentiment flag-sentiment-${row.item.sentiment}`"
                  >
                    {{ formatSentiment(row.item.sentiment) }}
                  </span>
                </div>
              </template>
              <!-- Score  -->
              <template v-slot:cell(score)="row">
                <div>
                  <span
                    class="sentimentScore"
                    :class="`flag-sentiment-${row.item.sentiment}`"
                  >
                    {{ formatScore(row.item.score) }}
                  </span>
                </div>
              </template>
              <!-- Keywords  -->
              <template v-slot:cell(keywords)="row">
                <ul>
                  <li v-for="(item, index) in row.item.keywords" :key="index">
                    {{ item }}
                  </li>
                </ul>
              </template>
              <template v-slot:cell(options)="row">
                <router-link
                  :to="`/treatments/${row.item._id}`"
                  class="mr-2 table-icons"
                  :title="`${$t('answers.details')}`"
                >
                  <font-awesome-icon :icon="['fa', 'search']" />
                </router-link>
              </template>
              <!-- End Fields -->
            </b-table>
            <div class="footer" v-show="!loading">
              <div class="pagination-area-answers">
                <paginate
                  v-model="page"
                  :pageCount="Math.ceil(summary.total / this.limit)"
                  :clickHandler="updateTable"
                  :prevText="'‹'"
                  :nextText="'›'"
                  :activeClass="'active'"
                  :containerClass="'pagination b-pagination'"
                  :pageClass="'page-item'"
                ></paginate>
              </div>
              <div>
                <button
                  style="
                    padding: 0;
                    border: none;
                    background: none;
                    margin-right: 10px;
                  "
                  @click="download('csv')"
                  title="Exportar para csv"
                >
                  <span class="xls">
                    <i class="fas fa-file-csv"></i>
                  </span>
                </button>

                <button
                  style="padding: 0; border: none; background: none;"
                  @click="download('xlsx')"
                  title="Exportar para xlsx"
                >
                  <span class="xls">
                    <i class="fas fa-file-download"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate';
import { mapState, mapActions } from 'vuex';
import swal from 'sweetalert';
import api from '@/services/api';
import { mapFields } from 'vuex-map-fields';
import { lightFormat } from 'date-fns';
import dashboardBar from '@/components/molecules/dashboard-bar';
import EventBus from '../../../eventBus';

export default {
  components: { Paginate, dashboardBar },

  data: () => ({
    userAuth: null,
    profileOptions: [],
    sentimentOptions: [],
    filter: null,
    typingTimer: null,
    options: [],
    fields: [],
    items: [],
    loading: false,
    limit: 10,
    sortBy: null,
    sortDesc: null,
    profileSelect: null,
    sentimentSelect: null,
  }),

  computed: {
    ...mapState('treatments', ['answer', 'summary']),
    ...mapState('authentication', ['userProfile']),
    ...mapState('companies', ['myMetric']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('authentication', ['userProfile']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    ...mapFields('treatments', ['page']),
  },

  methods: {
    ...mapActions('treatments', ['setAnswers']),

    async download(type) {
      this.apiServerlessDownloads = process.env.API_SERVERLESS_DOWNLOADS;
      try {
        await api.get(
          `${this.apiServerlessDownloads}/answers/download/${this.userAuth.companyId}/${type}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              startDate: this.calendarDates.start,
              endDate: this.calendarDates.end,
              filter: this.filter,
              actionId:
                  this.myActionsIds.length === 0
                    ? null
                    : JSON.stringify(this.myActionsIds),
                ih1:
                  this.myHierarchies1.length === 0
                    ? null
                    : JSON.stringify(this.myHierarchies1),
                ih2:
                  this.myHierarchies2.length === 0
                    ? null
                    : JSON.stringify(this.myHierarchies2),
              groupId: this.actionGroupData._id,
              metric: this.myMetric,
              indicator: this.indicatorName,
              isSentiment: true,
              grade: this.grade,
              selectComments: true,
              sentimentSelect: this.sentimentSelect,
              profile: this.profileSelect,
              indicatorValue: this.indicatorData.value,
              indicatorRange: this.indicatorData.range,
            },
          },
        );
        swal({
          title: this.$t('answers.donwload.title'),
          text: this.$t('answers.donwload.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$t('answers.ops'),
          text: 'error',
          icon: 'error',
        });
      }
    },

    async selectProfile() {
      if (this.profileSelect) {
        this.replaceQueryParams({ profile: this.profileSelect });
        await this.updateTable();
      }
    },

    async selectSentiment() {
      if (this.sentimentSelect) {
        this.replaceQueryParams({ sentiment: this.sentimentSelect });
        await this.updateTable();
      }
    },

    checkName(anonymous, name) {
      if (anonymous) {
        return 'Anônimo';
      } else if (this.userProfile.permissions.answers.anonymous_profile) {
        return '**************';
      } else if (name) {
        return name;
      }
      return 'Sem Nome';
    },

    checkUserData(anonymous, value) {
      if (anonymous) {
        return '***************';
      } else if (this.userProfile.permissions.answers.anonymous_profile) {
        return '***************';
      } else if (value) {
        return value;
      }
      return '-';
    },

    replaceQueryParams(object) {
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, ...object },
      });
    },

    searchByFilter() {
      if (this.filter !== '' && this.filter !== null) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTable, 600);
      }
      if (this.filter === '') {
        this.filter = null;
        this.updateTable();
      }
    },

    cleanFilter() {
      this.filter = null;
      this.updateTable();
    },

    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.updateTable();
    },

    dateFormat(param) {
      const day = lightFormat(new Date(param), 'dd/MM/yyyy');
      const hour = lightFormat(new Date(param), 'HH:mm');
      return `${day} às ${hour}`;
    },

    formatSentiment(sentiment) {
      let label = '';
      switch (sentiment) {
        case 'negative':
          label = this.$t('sentiment.sentimentSelect.negative');
          break;
        case 'neutral':
          label = this.$t('sentiment.sentimentSelect.neutral');
          break;
        case 'positive':
          label = this.$t('sentiment.sentimentSelect.positive');
          break;
        default:
          break;
      }
      return label;
    },

    formatScore(score) {
      let myScore = (score * 100).toFixed(0);
      if (score >= 0) {
        myScore = `+${myScore}`;
      }
      return myScore;
    },

    gradeFormat(grade) {
      if (this.myMetric === 'nps-0-10') {
        if (grade >= 9 && grade <= 10) {
          return 'promoters';
        } else if (grade === 7 || grade === 8) {
          return 'neutral';
        } else if (grade < 7) {
          return 'detractors';
        }
        return 'invalid';
      } else if (
        this.myMetric === 'nps-1-5' ||
        this.myMetric === 'ces-1-5' ||
        this.myMetric === '5-stars'
      ) {
        if (grade > 3 && grade < 6) {
          return 'promoters';
        } else if (grade === 3) {
          return 'neutral';
        } else if (grade < 3) {
          return 'detractors';
        }
        return 'invalid';
      }
      return 'invalid';
    },
    //  observação
    changeLabels() {
      this.profileOptions = [
        { value: null, text: this.$t('answers.profileSelect.select') },
        { value: 'all', text: this.$t('answers.profileSelect.all') },
        {
          value: 'detractors',
          text: this.$t('answers.profileSelect.detractors'),
        },
        { value: 'passives', text: this.$t('answers.profileSelect.neutral') },
        {
          value: 'promoters',
          text: this.$t('answers.profileSelect.promoters'),
        },
      ];
      this.sentimentOptions = [
        { value: null, text: this.$t('sentiment.sentimentSelect.select') },
        { value: 'all', text: this.$t('sentiment.sentimentSelect.all') },
        {
          value: 'positive',
          text: this.$t('sentiment.sentimentSelect.positive'),
        },
        {
          value: 'neutral',
          text: this.$t('sentiment.sentimentSelect.neutral'),
        },
        {
          value: 'negative',
          text: this.$t('sentiment.sentimentSelect.negative'),
        },
      ];
    },
    async updateTable() {
      this.loading = true;
      await this.setAnswers({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        queryParams: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          page: this.page,
          limit: this.limit,
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          filter: this.filter,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          sortBy: this.sortBy,
          sortDesc: this.sortDesc,
          selectComments: true,
          grade: this.grade,
          metric: this.myMetric,
          profile: this.profileSelect,
          onlySentiment: true,
          sentiment: this.sentimentSelect,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });

      this.items = [];

      for (let i = 0; i < this.answer.length; i += 1) {
        let sentiment = '';
        const keywords = this.getKeywords(
          this.answer[i].sentimentAnalyzeGCP.keyPhrases,
        );
        if (this.answer[i].sentimentAnalyzeGCP) {
          if (this.answer[i].sentimentAnalyzeGCP.score < 0) {
            sentiment = 'negative';
          } else if (this.answer[i].sentimentAnalyzeGCP.score >= 0.6) {
            sentiment = 'positive';
          } else {
            sentiment = 'neutral';
          }
        }
        this.items.push({
          _id: this.answer[i]._id,
          controlId: this.answer[i].controlId,
          date: this.answer[i].date,
          review: this.answer[i].review,
          name: this.answer[i].name,
          comment: this.answer[i].comment,
          sentiment,
          keywords,
          score: this.answer[i].sentimentAnalyzeGCP.score,
          phone: this.answer[i].phone,
          email: this.answer[i].email,
          channel: this.answer[i].channel,
          actionId: this.answer[i].actionId,
          feedback: this.answer[i].feedback,
          feedbackEdited: this.answer[i].feedbackEdited,
          anonymousResponse: this.answer[i].anonymousResponse,
        });
      }
      this.loading = false;
    },
    getKeywords(keyWordsList) {
      // eslint-disable-next-line
      let keywords = keyWordsList.sort().filter(function (item, pos, ary) {
        return !pos || item !== ary[pos - 1];
      });
      keywords = keywords.slice(0, 5);
      return keywords;
    },
  },
  watch: {
    actionGroupData: function watchActionGroup() {
      this.page = 1;
      this.updateTable();
    },

    myActionId: function watchmyActionId() {
      this.page = 1;
      this.updateTable();
    },

    myActionsIds: function watchmyActionsIds() {
      this.page = 1;
      this.updateTable();
    },

    calendarDates: function watchCalendarDates() {
      this.page = 1;
      this.updateTable();
    },

    myIh1: function watchMyIh1() {
      this.page = 1;
      this.updateTable();
    },

    myHierarchies1: function watchMyHierarchies1(){
      this.page = 1;
      this.updateTable();
    },

    myIh2: function watchMyIh2() {
      this.page = 1;
      this.updateTable();
    },

    myHierarchies2: function watchMyHierarchies2(){
      this.page = 1;
      this.updateTable();
    },

    myMetric: function watchMyMetric() {
      this.page = 1;
      this.updateTable();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.page = 1;
      this.updateTable();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      this.page = 1;
      this.updateTable();
    },
  },

  mounted() {
    EventBus.$on('changedLanguage', () => {
      this.changeLabels();
    });
    this.updateTable();
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.changeLabels();

    if (!this.userProfile.permissions.answers.menu) {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }
    this.fields = [
      // { key: 'controlId', label: this.$t('answers.answerTable.labels.id') },
      {
        key: 'date',
        label: this.$t('answers.answerTable.labels.date'),
        sortable: true,
      },
      /*
      {
        key: 'review',
        label: this.$t('answers.answerTable.labels.grade'),
        sortable: true,
      },
      */
      { key: 'name', label: this.$t('answers.answerTable.labels.client') },
      {
        key: 'comment',
        label: this.$t('answers.answerTable.labels.comment'),
      },
      {
        key: 'sentiment',
        label: this.$t('sentiment.table.sentiment'),
      },
      {
        key: 'score',
        label: this.$t('sentiment.table.score'),
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'keywords',
        label: this.$t('sentiment.table.keywords'),
      },
      {
        key: 'options',
        label: this.$t('sentiment.table.options'),
      },
    ];
  },
};
</script>
<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}

.wrapper {
  padding: 8px;
}

.wrapp {
  background-color: $white;
  padding: 16px;
  border: 1px solid $gray-light;
  border-radius: 4px;
}

.wrapp h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}

.header-icon {
  float: left;
  font-size: 12px;
  margin-top: 4px;
  padding-right: 12px;
  color: $gray;
}
.search-answers {
  display: flex;
  flex-direction: row;
  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}
.flag-grade {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: $white;
  font-weight: bold;
}
.flag-grade-promoters {
  background-color: #28a745;
}
.flag-grade-detractors {
  background-color: #dc3545;
}
.flag-grade-neutral {
  background-color: rgb(211, 211, 17);
}
.flag-grade-invalid {
  background-color: #c1c1c1;
}
.flag-sentiment {
  padding: 15px;
  font-size: 20px;
}
.flag-sentiment-negative {
  color: #dc3545;
}
.flag-sentiment-neutral {
  color: rgb(211, 211, 17);
}
.flag-sentiment-positive {
  color: #28a745;
}
.sentimentScore {
  font-size: 28px;
}
.footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.pagination-area-answers >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.table-icons {
  color: $primary;
  padding-left: 25px;
  font-size: 23px;

  svg {
    &:hover {
      color: #46b41e;
      cursor: pointer;
    }
  }
}
</style>

<style>
.pagination-area-answers .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}
.pagination-area-answers a {
  outline: none;
}

.data-filter {
  position: relative;
}
#sentiment-table {
  overflow: hidden;
}
#sentiment-table td {
  vertical-align: middle;
}
#sentiment-table img {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/sentiment/index.vue